export const DEFAULT_DUTY_TIMEZONE = 'Europe/Prague';
export function contactToContactWithDutyTrackingLike(input) {
    if (!(input.hasDutyTracking && input.crewId && input.userId)) {
        return null;
    }
    return {
        id: input.id,
        hasDutyTracking: input.hasDutyTracking,
        crewId: input.crewId,
        userId: input.userId,
        baseAirportIcaos: input.baseAirportIcaos || [],
    };
}
//# sourceMappingURL=ContactWithDutyTracking.js.map